<app-header></app-header>
<div class="main-container d-flex">
    <app-sidebar></app-sidebar>
    <div class="h-100p overflow-y-scroll w-100 pan-result-main">
        <div class="custom_container pan-result-layout">
            <div class="search-container">
                <!-- Top bar -->
                <div class="search-header">
                    <div class="header-left">
                        <button class="back-button" (click)="onBackButtonClick()">
                            <i class="bi bi-arrow-left"></i>
                            <span>Back</span>
                        </button>
                    </div>
                    <div class="header-center">
                        <h1 class="search-query">{{ formatPhone(mobilePanData?.phone || selectedSearchResult?.searched_phone) }}</h1>
                    </div>
                </div>

                <!-- Loader -->
                <div *ngIf="isLoadingResults" class="loading-container text-center my-3">
                    <div class="spinner-border text-primary" role="status"></div>
                    <p class="mt-2 text-main-color">Fetching results, please wait...</p>
                </div>

                <div class="container container--pan-result my-3 my-md-4 px-2 px-sm-3" *ngIf="!isLoadingResults && noRecords">
                    <div class="alert alert-warning mb-0">No Mobile PAN records found for this search.</div>
                </div>

                <!-- Search Results -->
                <div class="container container--pan-result my-3 my-md-4 px-2 px-sm-3" *ngIf="!isLoadingResults && mobilePanData">
                    <div class="main-pan-details-wrapper">
                        <div class="row g-3 quick-info-row">
                            <div class="col-12 col-sm-6 col-xl-3">
                                <div class="info-card info-card-gender">
                                    <div class="info-card-icon">
                                        <i class="bi bi-gender-ambiguous"></i>
                                    </div>
                                    <div class="info-card-content">
                                        <div class="label">Gender</div>
                                        <h4 class="my-2">{{ mobilePanData?.gender || '-' }}</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 col-xl-3">
                                <div class="info-card info-card-dob">
                                    <div class="info-card-icon">
                                        <i class="bi bi-calendar-event"></i>
                                    </div>
                                    <div class="info-card-content">
                                        <div class="label">Date of Birth</div>
                                        <h4 class="my-2">{{ formatDate(mobilePanData?.dob) }}</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 col-xl-3">
                                <div class="info-card info-card-aadhaar">
                                    <div class="info-card-icon">
                                        <i class="bi bi-credit-card-2-front"></i>
                                    </div>
                                    <div class="info-card-content">
                                        <div class="label">PAN</div>
                                        <h4 class="my-2">{{ mobilePanData?.pan || '-' }}</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 col-xl-3">
                                <div class="info-card info-card-masked">
                                    <div class="info-card-icon">
                                        <i class="bi bi-telephone"></i>
                                    </div>
                                    <div class="info-card-content">
                                        <div class="label">Phone</div>
                                        <h4 class="my-2">{{ formatPhone(mobilePanData?.phone) }}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="details-box personal-details-box">
                            <h5 class="details-heading"><i class="bi bi-person-vcard"></i>Personal Details</h5>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Full Name</p>
                                        <p>{{ mobilePanData?.name || '-' }}</p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">PAN Number</p>
                                        <p>{{ mobilePanData?.pan || '-' }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Date of Birth</p>
                                        <p>{{ formatDate(mobilePanData?.dob) || '-' }}</p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Gender</p>
                                        <p>{{ mobilePanData?.gender || '-' }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-6">
                                    <div class="detail-row">
                                        <p class="detail-label">Phone Number</p>
                                        <p>
                                            <span *ngIf="mobilePanData?.phone; else noPhone">
                                                <a [href]="'tel:' + formatPhone(mobilePanData.phone)" class="text-primary">{{ formatPhone(mobilePanData.phone) }}</a>
                                            </span>
                                            <ng-template #noPhone>-</ng-template>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="notes-section mt-3">
                            <div class="notes-header">
                                <i class="bi bi-journal-text"></i>
                                <span>Add Notes</span>
                            </div>
                            <div class="notes-content">
                                <textarea class="note-input" maxlength="300" placeholder="Notes" [(ngModel)]="notes"></textarea>
                                <div class="notes-footer">
                                    <span class="character-count">{{ notes.length }}/300</span>
                                    <button type="button" class="update-button" (click)="onUpdateNotesButtonClick()">
                                        Update Notes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>